export default __webpack_public_path__ + "static/media/orgArc.fed6fb53.png";